// polyfill
import 'reflect-metadata'

// styles
import 'ress' // reset css
import '@/assets/styles/_custom-theme.scss'

// vue
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { store, storeInjectionKey } from './store'
import { alertPlugin } from '@/libs/alertPortal'
import errorNotifierPlugin from '@/plugins/errorNotifier'
import apolloPlugin from '@/plugins/apollo'

import { setupNewRelic } from './newrelic'

import { setupGtm } from './gtm'
import VueGtag from 'vue-gtag-next'
import { createHead } from '@unhead/vue/client'

const run = async () => {
  const head = createHead()
  const app = createApp(App)
    .use(router)
    .use(store, storeInjectionKey)
    .use(head)
    .use(alertPlugin)
    .use(errorNotifierPlugin)
    .use(VueGtag, { property: { id: import.meta.env.VITE_GA_TRACKING_ID } })
    .use(apolloPlugin)

  setupGtm(app)
  setupNewRelic(app)

  await router.isReady()
  app.mount('#app')
}

void run()
